// extracted by mini-css-extract-plugin
module.exports = {"card":"SkipForm-styles-module--card--1fnLP"};